import React from 'react';
import { useTranslation } from 'react-i18next';
import { ColorScheme } from 'shared/assets/styles';
import { PremiumOverlay } from 'shared/components/connected/premium-overlay';
import { useTheme } from 'styled-components';

import * as Styled from './premium-message.style';

export const PremiumMessage: React.FC = () => {
  const { t } = useTranslation();
  const theme = useTheme();

  return (
    <PremiumOverlay
      title={t('pages.insights.premium.title')}
      description={t('pages.insights.premium.description')}
    >
      {theme.colorScheme === ColorScheme.Dark ? (
        <Styled.Image src="/images/premium/insights-no-premium-graphic-dm.jpg" />
      ) : (
        <Styled.Image src="/images/premium/insights-no-premium-graphic-lm.jpg" />
      )}
    </PremiumOverlay>
  );
};
